import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Slim back-to-home strip used on destination pages whose primary
 * component already renders its own hero heading (Services, Gallery,
 * BookingBlock, MeetYolanda, ReviewCarousel, Location).
 */
export default function PageBackBar({ testId = "page-back-bar" }) {
  return (
    <div
      className="pt-24 md:pt-28 bg-black border-b border-white/10"
      data-testid={testId}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pb-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 eyebrow text-zinc-500 hover:text-white transition-colors"
          data-testid="page-header-back"
        >
          <ArrowLeft className="w-3 h-3" strokeWidth={1.5} />
          Home
        </Link>
      </div>
    </div>
  );
}
